import {CPOMastheadTranslations} from '../typing/translations';
import {useInventory} from './use-inventory';

export function useTranslations(): CPOMastheadTranslations {
  return useInventory().translations;
}
